<template>
  <!-- Flash messages are now shown as toasts only -->
</template>

<script>
import { useToast } from "vue-toastification";

export default {
  name: 'FlashMessage',
  
  mounted() {
    this.showToastIfNeeded();
  },
  
  methods: {
    showToastIfNeeded() {
      // Check if we have a flash message and show it as a toast
      if (this.$page.props.flash && this.$page.props.flash.message && this.$page.props.flash.status) {
        const toast = useToast();
        const message = this.$page.props.flash.message;
        const status = this.$page.props.flash.status;
        
        if (status === 'success') {
          toast.success(message, {
            position: 'top-right',
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            closeButton: "button",
            icon: true,
            rtl: false
          });
        } else if (status === 'error') {
          toast.error(message);
        }
      }
    }
  }
};
</script>